import type { ThemeColorPreset } from '@sites/site-theme/src/types/theme-color.type';

import { hashCode } from '@common/helpers/hash';

import { DEFAULT_COLOR_PRESETS } from './color-presets.const';
import { ThemeColorNames } from '@sites/site-theme/src/enums/color-names.enum';

export function getThemeColorPresets(): ThemeColorPreset[] {
    const colorNames: ThemeColorNames[] = Object.values(ThemeColorNames);
    return DEFAULT_COLOR_PRESETS.map((preset: string[]) => ({
        index: hashCode(preset),
        values: colorNames.map((name: ThemeColorNames, idx: number) => ({ name, value: preset[idx]! })),
    }));
}
